var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 17,
    viewBox: "0 0 6 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.25C2.5875 14.25 2.23438 14.1031 1.94063 13.8094C1.64688 13.5156 1.5 13.1625 1.5 12.75C1.5 12.3375 1.64688 11.9844 1.94063 11.6906C2.23438 11.3969 2.5875 11.25 3 11.25C3.4125 11.25 3.76562 11.3969 4.05938 11.6906C4.35313 11.9844 4.5 12.3375 4.5 12.75C4.5 13.1625 4.35313 13.5156 4.05938 13.8094C3.76562 14.1031 3.4125 14.25 3 14.25ZM3 9.75C2.5875 9.75 2.23438 9.60313 1.94063 9.30938C1.64688 9.01563 1.5 8.6625 1.5 8.25C1.5 7.8375 1.64688 7.48438 1.94063 7.19063C2.23438 6.89687 2.5875 6.75 3 6.75C3.4125 6.75 3.76562 6.89687 4.05938 7.19063C4.35313 7.48438 4.5 7.8375 4.5 8.25C4.5 8.6625 4.35313 9.01563 4.05938 9.30938C3.76562 9.60313 3.4125 9.75 3 9.75ZM3 5.25C2.5875 5.25 2.23438 5.10313 1.94063 4.80938C1.64688 4.51562 1.5 4.1625 1.5 3.75C1.5 3.3375 1.64688 2.98438 1.94063 2.69063C2.23438 2.39688 2.5875 2.25 3 2.25C3.4125 2.25 3.76562 2.39688 4.05938 2.69063C4.35313 2.98438 4.5 3.3375 4.5 3.75C4.5 4.1625 4.35313 4.51562 4.05938 4.80938C3.76562 5.10313 3.4125 5.25 3 5.25Z",
    fill: "#CBCBCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.6a9dc2d32873d48483c3e5003b12469f.svg";
export { ForwardRef as ReactComponent };